import type { UppFloorPlanVertex } from '../plan/floor-plan-element';

/** Geometric centre of the vertex marker box in room cm (polylines and circles use this point). */
export function floorPlanVertexCenterCm(v: UppFloorPlanVertex): { xCm: number; yCm: number } {
  return {
    xCm: v.xCm + v.widthCm / 2,
    yCm: v.yCm + v.heightCm / 2,
  };
}
